export const heroData = {
  title: "云开体育",
  subtitle: "专业体育服务平台",
  description: "云开体育是您值得信赖的专业体育服务平台，提供体育培训、赛事组织、运动健身、体育场馆预约等一站式服务。让更多人享受运动乐趣，助力全民健身事业蓬勃发展。",
  ctaPrimary: "立即体验",
  ctaSecondary: "了解更多",
  stats: [
    { value: "50,000+", label: "活跃会员" },
    { value: "200+", label: "合作场馆" },
    { value: "500+", label: "专业教练" },
    { value: "98%", label: "满意度" },
  ],
};

export const servicesData = [
  {
    icon: "ri-user-star-line",
    title: "体育培训",
    description: "汇聚500多名专业教练，涵盖篮球、足球、游泳、羽毛球、网球等30多种运动项目，为不同年龄段学员提供个性化培训方案。从入门到进阶，系统提升运动技能水平。",
    slug: "training",
  },
  {
    icon: "ri-trophy-line",
    title: "赛事组织",
    description: "专业赛事策划与执行团队，每年组织超200场各类体育赛事。从企业团建赛事到大型公开赛，提供赛程编排、裁判派遣、场地协调、成绩统计等全流程服务。",
    slug: "events",
  },
  {
    icon: "ri-heart-pulse-line",
    title: "运动健身",
    description: "科学的健身课程体系，包括瑜伽、普拉提、力量训练、有氧操、HIIT等多样化课程。配备专业体测设备和营养指导，制定专属健身计划，助您达成健康目标。",
    slug: "fitness",
  },
  {
    icon: "ri-building-line",
    title: "场馆预约",
    description: "覆盖全国200多家优质体育场馆，支持在线实时预约。篮球场、足球场、游泳馆、羽毛球场、网球场、健身房等丰富场馆类型，价格透明，随时可订。",
    slug: "venues",
  },
  {
    icon: "ri-parent-line",
    title: "青少年训练",
    description: "专为6-18岁青少年设计的运动成长体系。体能基础训练、专项技能培养、运动心理辅导三位一体，培养运动兴趣，塑造坚韧品格，让运动成为孩子最好的成长伙伴。",
    slug: "youth",
  },
  {
    icon: "ri-vip-crown-line",
    title: "会员服务",
    description: "云开体育会员享有多重专属权益：课程折扣、优先预约、专属教练、免费体测、生日礼遇等。不同等级会员卡满足不同需求，让您的运动生活更加便捷实惠。",
    slug: "membership",
  },
];

export const coursesData = [
  {
    id: 1,
    title: "篮球精英训练营",
    category: "体育培训",
    level: "中级",
    duration: "12课时",
    price: 2880,
    image: "https://readdy.ai/api/search-image?query=Professional%20basketball%20training%20session%20in%20modern%20indoor%20court%20with%20coach%20teaching%20young%20athlete%20dribbling%20techniques%2C%20bright%20lighting%2C%20clean%20minimal%20background%2C%20sports%20photography%20style%20with%20sharp%20details&width=800&height=600&seq=course-basketball&orientation=landscape",
    rating: 4.9,
    students: 1286,
  },
  {
    id: 2,
    title: "游泳私教一对一",
    category: "体育培训",
    level: "入门",
    duration: "10课时",
    price: 3600,
    image: "https://readdy.ai/api/search-image?query=Professional%20swimming%20coach%20providing%20one%20on%20one%20lesson%20in%20clean%20modern%20indoor%20pool%20with%20crystal%20clear%20water%2C%20bright%20natural%20lighting%20through%20large%20windows%2C%20minimal%20simple%20background&width=800&height=600&seq=course-swimming&orientation=landscape",
    rating: 4.8,
    students: 956,
  },
  {
    id: 3,
    title: "瑜伽身心平衡课",
    category: "运动健身",
    level: "全级别",
    duration: "20课时",
    price: 1980,
    image: "https://readdy.ai/api/search-image?query=Serene%20modern%20yoga%20studio%20with%20natural%20wooden%20floor%2C%20soft%20warm%20lighting%2C%20group%20of%20people%20practicing%20yoga%20poses%20with%20instructor%2C%20minimal%20clean%20aesthetic%2C%20peaceful%20atmosphere&width=800&height=600&seq=course-yoga&orientation=landscape",
    rating: 4.9,
    students: 2150,
  },
  {
    id: 4,
    title: "青少年足球青训",
    category: "青少年训练",
    level: "基础",
    duration: "16课时",
    price: 3200,
    image: "https://readdy.ai/api/search-image?query=Youth%20soccer%20training%20session%20on%20green%20artificial%20turf%20field%20with%20coach%20guiding%20young%20players%2C%20bright%20sunny%20day%2C%20vibrant%20colors%2C%20clean%20simple%20background%20with%20modern%20sports%20facility&width=800&height=600&seq=course-football&orientation=landscape",
    rating: 4.7,
    students: 1832,
  },
];

export const eventsData = [
  {
    id: 1,
    title: "2026云开体育城市篮球联赛",
    date: "2026年9月15日",
    location: "北京国家体育中心",
    status: "报名中",
    image: "https://readdy.ai/api/search-image?query=Exciting%20basketball%20game%20in%20large%20modern%20arena%20with%20bright%20lights%2C%20players%20in%20action%20on%20court%2C%20energetic%20atmosphere%2C%20professional%20sports%20photography%20with%20dramatic%20lighting&width=800&height=500&seq=event-basketball-league&orientation=landscape",
    participants: 320,
  },
  {
    id: 2,
    title: "全民健身游泳挑战赛",
    date: "2026年10月8日",
    location: "上海浦东游泳馆",
    status: "即将开始",
    image: "https://readdy.ai/api/search-image?query=Competitive%20swimming%20race%20in%20professional%20indoor%20pool%2C%20athletes%20diving%20and%20swimming%2C%20bright%20clean%20lighting%2C%20modern%20aquatic%20center%2C%20professional%20sports%20event%20photography&width=800&height=500&seq=event-swimming&orientation=landscape",
    participants: 180,
  },
  {
    id: 3,
    title: "云开体育羽毛球公开赛",
    date: "2026年11月20日",
    location: "广州天河体育中心",
    status: "预告",
    image: "https://readdy.ai/api/search-image?query=Professional%20badminton%20match%20in%20modern%20indoor%20sports%20hall%2C%20player%20smashing%20shuttlecock%2C%20bright%20clean%20court%20with%20green%20floor%2C%20dynamic%20action%20shot%2C%20professional%20sports%20photography&width=800&height=500&seq=event-badminton&orientation=landscape",
    participants: 0,
  },
];

export const venuesData = [
  {
    id: 1,
    name: "云开体育中心旗舰馆",
    type: "综合体育馆",
    address: "北京市朝阳区奥林匹克公园内",
    rating: 4.9,
    price: "80元/小时起",
    image: "https://readdy.ai/api/search-image?query=Modern%20comprehensive%20sports%20center%20exterior%20with%20glass%20facade%20and%20clean%20architectural%20design%2C%20bright%20sunny%20day%2C%20landscaped%20surroundings%2C%20professional%20architectural%20photography%20with%20warm%20natural%20light&width=800&height=500&seq=venue-flagship&orientation=landscape",
    facilities: ["篮球", "游泳", "健身", "羽毛球"],
  },
  {
    id: 2,
    name: "浦东运动天地",
    type: "健身中心",
    address: "上海市浦东新区陆家嘴金融区",
    rating: 4.8,
    price: "60元/小时起",
    image: "https://readdy.ai/api/search-image?query=Modern%20fitness%20center%20interior%20with%20state%20of%20the%20art%20equipment%2C%20large%20windows%20with%20city%20view%2C%20bright%20natural%20lighting%2C%20clean%20minimal%20design%20with%20wooden%20accents&width=800&height=500&seq=venue-pudong&orientation=landscape",
    facilities: ["健身", "瑜伽", "普拉提", "动感单车"],
  },
  {
    id: 3,
    name: "天河体育公园",
    type: "户外运动场",
    address: "广州市天河区体育西路",
    rating: 4.7,
    price: "40元/小时起",
    image: "https://readdy.ai/api/search-image?query=Beautiful%20outdoor%20sports%20park%20with%20green%20grass%20fields%20and%20running%20tracks%2C%20surrounded%20by%20trees%2C%20bright%20sunny%20day%20with%20blue%20sky%2C%20modern%20urban%20sports%20facility%20photography&width=800&height=500&seq=venue-tianhe&orientation=landscape",
    facilities: ["足球", "网球", "跑步", "篮球"],
  },
];

export const membershipData = [
  {
    id: 1,
    name: "基础会员",
    price: 299,
    unit: "元/月",
    color: "secondary",
    features: [
      "场馆预约9折优惠",
      "每月2节免费团课",
      "会员专属活动参与权",
      "运动数据记录与分析",
      "APP在线客服支持",
    ],
  },
  {
    id: 2,
    name: "进阶会员",
    price: 599,
    unit: "元/月",
    color: "primary",
    popular: true,
    features: [
      "场馆预约8折优惠",
      "每月6节免费团课",
      "2次私教体验课",
      "优先赛事报名权",
      "专属运动计划定制",
      "免费体测服务（每季度）",
      "生日专属礼遇",
    ],
  },
  {
    id: 3,
    name: "至尊会员",
    price: 999,
    unit: "元/月",
    color: "accent",
    features: [
      "场馆预约7折优惠",
      "无限次免费团课",
      "每月4节私教课",
      "VIP赛事通道及优先座席",
      "一对一营养顾问",
      "不限次体测服务",
      "专属客服经理",
      "年度运动装备礼包",
    ],
  },
];

export const youthData = {
  title: "青少年运动成长计划",
  description: "专为6-18岁青少年打造的科学运动培养体系，通过专业训练帮助孩子建立运动习惯，培养坚韧品格，让运动成为最好的成长伙伴。",
  features: [
    { icon: "ri-brain-line", title: "体能基础开发", desc: "全面提升力量、速度、耐力、柔韧、协调五大基础体能素质" },
    { icon: "ri-medal-line", title: "专项技能培养", desc: "篮球、足球、游泳、网球等12个专项方向，因材施教" },
    { icon: "ri-mental-health-line", title: "运动心理辅导", desc: "专业运动心理咨询师辅助，培养抗压能力和团队协作精神" },
    { icon: "ri-calendar-check-line", title: "成长跟踪体系", desc: "定期体测评估，数字化记录成长轨迹，科学调整训练方案" },
  ],
};

export const faqData = [
  {
    question: "如何成为云开体育会员？",
    answer: "您可以通过云开体育官网或APP注册成为会员。注册时填写基本信息，选择您感兴趣的会员等级（基础、进阶或至尊），完成支付后即可享受对应会员权益。新会员注册即享7天免费体验。",
  },
  {
    question: "预约场馆后可以取消吗？",
    answer: "可以的。预约场馆后，在开场时间前2小时可免费取消；2小时内取消将收取50%的费用；开场后不支持取消。特殊情况可联系客服处理。",
  },
  {
    question: "体育培训课程如何选择？",
    answer: "我们提供入门、中级、高级三个级别的课程。建议新学员先预约一次免费体验课，教练会根据您的运动基础和训练目标，为您推荐最适合的课程方案。",
  },
  {
    question: "青少年训练适合什么年龄段？",
    answer: "云开体育青少年训练计划面向6-18岁的儿童和青少年。我们根据年龄段分为：幼儿启蒙（6-8岁）、少儿基础（9-12岁）、青少年进阶（13-15岁）、青年精英（16-18岁）四个阶段，每个阶段都有对应的训练目标和课程体系。",
  },
  {
    question: "赛事报名后能否退款？",
    answer: "赛事报名成功后，在报名截止日期前可全额退款；报名截止后至比赛开始前7天可退50%；比赛开始前7天内不支持退款。如因不可抗力导致赛事取消，将全额退款。",
  },
];

export const partnersData = [
  "中国篮球协会", "国家体育总局", "北京市体育局", "上海体育学院",
  "耐克中国", "安踏体育", "李宁公司", "腾讯体育",
];